import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  TAdditionalValuesWidget,
  TCommonTableData,
  TDashboardRequest,
  TExpectedSavingPeriodItem,
  TSavingsResponce
} from './types'
import { ResponseWithPagination, TOptionsResponse } from '../../constants'
import { TOngoingItem } from './Charts/types'
import {
  TAdditionalValue,
  TAdditionalValuesTableRequestData
} from '../AdditionalValues/types'
import { CCAddRemoveToHospitalUserRequest } from '../UserContractCategories/types'
import { TExpectedSavingsByCategoryWidgetResponse } from './ExpectedSavingsByCategory/types'

const fetcher = new Fetcher({})

export const getSavings = (data) =>
  fetcher.request<TDashboardRequest, TSavingsResponce>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.SAVINGS_DASHBOARD}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getOngoing = (data?: TDashboardRequest) =>
  fetcher.request<TDashboardRequest, TOngoingItem>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ONGOING_DASHBOARD}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getSavingsSummaryList = async (data) =>
  fetcher.request<TDashboardRequest, ResponseWithPagination<TCommonTableData>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.SAVINGS_DASHBOARD}${API_DICTIONARY.SAVINGS_SUMMARY_TABLE}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getExpectedSavingsList = async (data) =>
  fetcher.request<
    TDashboardRequest,
    ResponseWithPagination<TExpectedSavingPeriodItem>
  >({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.SAVINGS_DASHBOARD}${API_DICTIONARY.SAVINGS_GOAL}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getAdditionalValuesTable = async (data) =>
  fetcher.request<
    TAdditionalValuesTableRequestData,
    ResponseWithPagination<TAdditionalValue>
  >({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getAdditionalValuesTypesList = async (data?: TDashboardRequest) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.TYPE}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getAdditionalValuesSubTypesList = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.SUBTYPE}`,
    method: HTTP_METHODS.GET
  })
export const getAdditionalValuesSummary = async (data?: TDashboardRequest) =>
  fetcher.request<unknown, TAdditionalValuesWidget>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.SUMMARY}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const deleteAdditionalValue = ({ uuid }) =>
  fetcher.request<CCAddRemoveToHospitalUserRequest, unknown>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${uuid}/`,
    method: HTTP_METHODS.DELETE
  })

export const getExpectedSavingsByCategoryRequest = async (
  data?: TDashboardRequest
) =>
  fetcher.request<unknown, TExpectedSavingsByCategoryWidgetResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.SUMMARY}${API_DICTIONARY.CATEGORY}`,
    method: HTTP_METHODS.GET,
    ...data
  })
